module.exports = __webpack_public_path__ + "static/media/klefki.8c782a10.png";